export default __webpack_public_path__ + "static/media/arihant3.f3388f7e.png";